export const projects = [
  {
    id: 1,
    title: 'Tasks Manager',
    description:
      'Fullstack Task Manager App. Stack: Next.js, Clerk, Prisma, Postgresql, Typescript, Tailwind, Styled-components, Axios',
    image: './imgs/TaskManager.png',
    url: 'https://famous-raindrop-4c59e1.netlify.app/',
  },
  {
    id: 2,
    title: 'Coffee House',
    description:
      'RSSchool project. Layout of a responsive and adaptive coffee shop website based on Figma. Implemented burger menu for tablet and mobile, auto-slider, category switching for products, modal for the selected product. Stack: HTML, Sass, JS, JSON',
    image: './imgs/CoffeeHouse.png',
    url: 'https://coffee-house-olive.vercel.app/index.html',
  },
  {
    id: 3,
    title: 'Med Connect',
    description:
      'Doctor Appointment Booking Application. Implemented registration and login, booking appointments, applying doctors. Users have roles with themselves functionality. Stack: React, Redux, Antd, Firebase.',
    image: './imgs/MedConnect.png',
    url: 'https://med-connects.netlify.app',
  },
  {
    id: 4,
    title: 'Interview List',
    description:
      'Application for maintaining statistics on job responses and interviews completed. Stack: Vue, Vue-router, Pinia, Firebase, Typescript, Primevue, Vite, Chart.js, Dayjs',
    image: './imgs/InterviewList.png',
    url: 'https://interview-list.netlify.app/',
  },
  {
    id: 5,
    title: 'Sunduki',
    description:
      'Sunduki is a landing page for a museum, art space, coliving and coworking space. Commercial development. Stack: HTML5, CSS3, Scss, BAM.',
    image: './imgs/SundukiByngi.png',
    url: 'https://pacificaelise.github.io/Sunduki/',
  },
  {
    id: 6,
    title: 'IP address Tracker',
    description:
      'Geolocation Tracker app helping to search for any IP addresses or domains and see the key information and location. Stack: HTML, CSS, JS, Parcel-bundler, Babel-polyfill, Free IP Geo Location, Leaflet (map API).',
    image: './imgs/IPAddressTracker.png',
    url: 'https://geolocation-three-henna.vercel.app/',
  },
  {
    id: 7,
    title: 'Online Store',
    description:
      'Layout of an online store website using Figma layout. Stack: HTML5, Scss, BEM, adaptive and cross-browser layout.',
    image: './imgs/Shop.png',
    url: 'https://pacificaelise.github.io/Team-project/',
  },
  {
    id: 8,
    title: 'Learn language',
    description:
      'Application (SPA) for learning foreign words. Interaction with the API has been implemented: adding new words, editing, deleting. Added validation, search, pagination. Stack: React, MobX, Router, css modules, API, JSON, Github.',
    image: './imgs/EnglishCardsApp.png',
    url: 'https://pacificaelise.github.io/english-cards',
  },
  {
    id: 9,
    title: 'Pure City',
    description:
      'Eco-camp website created during a hackathon on the topic “Social Projects”. Stack: HTML5, CSS3, BEM, adaptive layout, JS.',
    image: './imgs/PureCity.png',
    url: 'https://pacificaelise.github.io/ProjectHackathon/',
  },
];
